<template>
  <div class="hello">
    <div class="yihang" v-for="(item , i) in emuOWebtList" :key="i">
      <div style="padding-left: 50px;">


        <span class="hcqStyle5 text">{{ item[0].ssemuinname }} {{ item[0].ssemuname }} </span><br>
        
        <button v-for="(item_item , i2) in item"
         :title="item_item.sswebaddr"  class="my-button"
         :style="item_item.ssdirect ? item_item.sskbn === '1' ? { 'background-color': '#4CAF50'} : item_item.sskbn === '2' ? { 'background-color': '#1c83d6'} : { 'background-color': '#58486d'}
         : item_item.sskbn === '1' ? { 'background-color': '#99c99b'} : item_item.sskbn === '2' ? { 'background-color': '#92bbdd'} : { 'background-color': '#c2a5e9'}"
         :key="'div' + i + 'btn' + i2" @click="goUrl(item_item.sswebaddr)">
         {{ item_item.sskbn === '1' ? '官' : item_item.sskbn === '2' ? '源' : '他' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TV3',
  data(){
    return {
      emuOWebtList:[]
    };
  },
  props: {
    msg: String
  },
  methods:{
    showAll(){
        let _this = this;
        this.emuOWebtList = []
        this.$axios.post('/ssBaseS3Controller/watchTVat3.do',)
        .then(res => {
          
          let tempEmuCd = '', tempEmussemuinname = '', templist, tempemuOWebtList = []
          res.emuOWebtList.forEach(e => {
            //debugger
            if(tempEmuCd != e.ssemuinnamecd || (tempEmussemuinname?tempEmussemuinname:'') != (e.ssemuname? e.ssemuname:'')) {
              tempEmuCd = e.ssemuinnamecd;
              tempEmussemuinname = e.ssemuname;
              templist = []
              tempemuOWebtList.push(templist);
            }
            templist.push(e);
          })

            _this.emuOWebtList = tempemuOWebtList;
        })
    },
    goUrl(ur){
      // console.log(ur);
      window.open(ur, '_blank')
    }
  },
  created:function () {//组件实例化之后执行，页面尚未显示
      this.showAll();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.yihang{
  border: 1px solid #cceff5;
  background: #fafcfd;
  width: 800px;
  margin-bottom: 4px;
  text-align: left;
}


.my-button {
  display: inline-block;
  padding: 12px 24px;
  /* background-color: #4CAF50; */
  background-color: #c2a5e9;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12);
  transition: box-shadow 0.3s ease-in-out;
}
 
.my-button:hover, .my-button:focus {
  box-shadow: 0 6px 12px 0 rgba(0,0,0,0.24), 0 6px 20px 0 rgba(0,0,0,0.19);
} 

.hcqStyle5{
  color: transparent;background-color : blue;
  text-shadow : rgba(255,255,255,0.5) 0 5px 6px, rgba(255,255,255,0.2) 1px 3px 3px;
  -webkit-background-clip : text;
}  

  .text-reflect-base{color: palegreen;-webkit-box-reflect:below 10px;}
    .text{
        width: 300px;
        height: 200px;
        /* position: absolute;
        left: 50%;
        margin-left: -150px; */
        background-image: -webkit-linear-gradient(left,blue,#66ffff 10%,#cc00ff 20%,#CC00CC 30%, #CCCCFF 40%, #00FFFF 50%,#CCCCFF 60%,#CC00CC 70%,#CC00FF 80%,#66FFFF 90%,blue 100%);
        -webkit-text-fill-color: transparent;
        -webkit-background-clip: text;
        -webkit-background-size: 200% 100%; 
        -webkit-animation: masked-animation 4s linear infinite;
        font-size: 35px;
    }
    /* @keyframes masked-animation {
        0% {
            background-position: 0  0;
        }
        100% {
            background-position: -100%  0;
        }
    } */

</style>
